<template>

  <div class="row collapse slide">

    <div class="column small-22 small-offset-1" v-if="slide">
      <div class="row collapse">

        <div class="column small-18 small-offset-2 medium-10 medium-offset-6 mediumlarge-12 mediumlarge-offset-0 mediumlarge-push-13">
          <div class="image-wrapper">

            <img v-if="generatedImageSource" :src="generatedImageSource"/>
            <slot v-if="$scopedSlots['image']" name="image"></slot>

          </div>
        </div>

        <div class="column mediumlarge-12 mediumlarge-pull-12">
          <div class="text" v-if="$scopedSlots['content']">
            <slot name="content"></slot>
          </div>
          <div class="text" v-else>
            <h2 v-html="interpolate(slide.title)"></h2>
            <p v-html="interpolate(slide.text)"></p>
          </div>
        </div>

      </div>
    </div>

    <slot v-else></slot>

  </div>

</template>

<script>
export default {
  name: 'slide',

  props: {
    slide: {
      type: Object,
      required: false,
    },
    imageSource: {
      type: String,
      required: false
    }
  },

  computed: {
    generatedImageSource() {
      if (this.imageSource) {
        return this.imageSource
      } else if (this.slide.imageSrc) {
        return require(`@/assets/${this.interpolate(this.slide.imageSrc)}`)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: auto;
}
.image-wrapper {
  float: right;
  width: 90%;
  margin-top: -5%;
}

h2 {
  color: $black;
  max-width: 100%;
  overflow: hidden;
  @include breakpoint(small) {
    font-size: rem-calc(35);
    line-height: rem-calc(40);
  }
}

p {
  font-size: rem-calc(20);
}

.start-animation{
  .swiper-slide-active{
    .text {
      animation: text 15s ease-in-out;
      animation-fill-mode: forwards;

      @include breakpoint(medium down) {
        animation: text-mobile 16s ease-in-out
      }
    }

    img {
      animation: graphic 15s ease-in-out;
      animation-fill-mode: forwards;

      @include breakpoint(medium down) {
        animation: graphic 16s ease-in-out
      }
    }
  }
}

@keyframes text {
  0%, 100% {
    opacity: 0;
    transform: translateX(-50px);
  }
  3%, 97% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes text-mobile {
  0%, 100% {
    opacity: 0;
    transform: translateY(50px);
  }
  3%, 97% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes graphic {
  0%, 100% {
    opacity: 0;
    transform: scale(0.75);
  }
  3%, 97% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Slide.vue